import ReactDOM from 'react-dom/client';


function App() {
  return (
    <h1>GLS Manager is not setup yet.</h1>
  )
}

ReactDOM.createRoot(document.getElementById('root')).render(<App/>);